
import Vue from 'vue';
import Component from 'vue-class-component';
import LoadingMixin from './loadingMixin';

@Component({
  name: 'LoadingTable',
})
export default class LoadingTable extends LoadingMixin { }
